function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getProfileFormFields } from '../reducer';
import UserInformationForm from './UserInformationForm';
var styles = {
  submit: ''
};
var Profile = function Profile(_ref) {
  var apiRoot = _ref.apiRoot,
    findPreferredGroups = _ref.findPreferredGroups,
    displayPassword = _ref.displayPassword,
    _ref$onUserInformatio = _ref.onUserInformationUpdated,
    onUserInformationUpdated = _ref$onUserInformatio === void 0 ? function () {} : _ref$onUserInformatio,
    updateAccount = _ref.updateAccount,
    updatePhoneVerificationDetails = _ref.updatePhoneVerificationDetails,
    userIdentity = _ref.userIdentity,
    formData = _ref.formData;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    processing = _useState2[0],
    setProcessing = _useState2[1];
  var fields = useSelector(getProfileFormFields);
  var updateUser = function updateUser(userUpdateRequest) {
    setProcessing(true);
    updateAccount(apiRoot, userIdentity, userUpdateRequest).then(function (_ref2) {
      var error = _ref2.error,
        user = _ref2.user;
      if (!error && user) {
        onUserInformationUpdated(user);
      }
      setProcessing(false);
    });
  };
  var updatePhoneVerification = function updatePhoneVerification(request) {
    return updatePhoneVerificationDetails(apiRoot, userIdentity, request);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-8"
  }, /*#__PURE__*/React.createElement(UserInformationForm, {
    displayPassword: displayPassword,
    fields: fields,
    findPreferredGroups: findPreferredGroups,
    formData: formData,
    persistData: function persistData(data) {
      return updateUser(data);
    },
    updatePhoneVerification: updatePhoneVerification,
    processing: processing,
    styles: styles,
    userIdentity: userIdentity
  }));
};
export default Profile;